module.exports = __webpack_public_path__ + "static/img/expellinginsects.8e70db4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/expellinginsects.png
// module id = P0vf
// module chunks = 58